/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { CanvasWidget } from "@projectstorm/react-canvas-core";
import "react-toastify/dist/ReactToastify.css";
import SideMenu from "./Components/sidebar/SideMenu";
import Context from "../store/context";

const { isSuperadmin } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

export default function MainWindow({
  redistribute,
  zoomToFit,
  loadProject,
  zoomToSelected,
  resetLayout,
}) {
  const [animatd, setAnimatd] = useState(false); // animation during zoom
  const { engine } = useContext(Context);
  return (
    <div
      className="main-window position-relative mb-n5"
      style={{
        height: isSuperadmin ? "calc(100vh - 160px)" : "calc(100vh - 140px)",
        display: "flex",
      }}
    >
      <SideMenu
        redistribute={redistribute}
        loadProject={loadProject}
        zoomToFit={zoomToFit}
        zoomToSelected={zoomToSelected}
        resetLayout={resetLayout}
      />
      <div
        style={{ flexGrow: 1, position: "relative" }}
        onDoubleClick={(e) => {
          setAnimatd(true);
          setTimeout(() => {
            setAnimatd(false);
          }, 300);
          zoomToSelected();
        }}
      >
        <CanvasWidget
          className={`bg-loop bg-accross diagram-container ${
            animatd ? " animated" : ""
          } `}
          engine={engine}
        />
      </div>
      <div id="sidebar" style={{ overflow: "auto", position: "relative" }} />
      <Outlet />
    </div>
  );
}
